export function createSnapshotFilters(isSuperAdministrator?: Boolean): FilterProperties[] {
  return [
    { label: "Author", property: 'author', type: 'string' },
    { label: "KVS Name", property: 'kvsName', type: "string" },
    { label: "Timestamp", property: 'timestamp', type: "date" },
    { label: "Created at", property: 'createdAt', type: "date" }
  ];
}